import React from 'react'
import betaSVG from './Beta.svg'
import './index.scss'

const BetaIcon = () => <img id="beta-icon" src={betaSVG} alt="" />

export default BetaIcon
